import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { StoreComponent } from '../store/store.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-store-list',
  templateUrl: './store-list.component.html',
  styleUrls: ['./store-list.component.css']
})
export class StoreListComponent implements OnInit {

  public menu_item_id = '42';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['store_name', 'store_name_en', 'branch_id', 'rep_name', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<StoreComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = {
    'table_name': 'store', 'store_name': '', 'store_name_en': '', 'branch_id': '0', 'rep_id': '',
    'comment': ''
  };

  Success_Msg; Error_Msg; Del_Msg; Without;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Without').subscribe((res: string) => {
      this.Without = res;
    });
  }

  branchList = [];

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query;
    let obj;

    query = this.queryList.all_branch;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

  }

  search() {
    let condition = "";
    if (this.model['store_name'] != '')
      condition = "(`store`.`store_name` LIKE '%" + this.model['store_name'] +
        "%' OR `store`.`store_name_en` LIKE '%" + this.model['store_name'] + "%') AND ";

    if (this.model['branch_id'] != '' && this.model['branch_id'] != '0')
      condition += "`store`.`branch_id` = '" + this.model['branch_id'] + "' AND ";
    /* if(this.model['rep_id'] != '') {
        condition +="`store`.`rep_id`=`employee`.`employee_id` AND `store`.`rep_id` = '" + this.model['rep_id'] + "' AND";
        }*/
    console.log(this.model['branch_id']);
    let query = "SELECT `store`.* ,`branch`.`branch_name` FROM `store`,`branch`" +
      " WHERE `store`.`branch_id` = `branch`.`branch_id`  AND " + condition + "`store`.`status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        data.data['list'].forEach(element => {
          if (element.rep_id == '0')
            element.rep_name = this.Without;
          else {
            let query1 = "SELECT `name` FROM `employee` WHERE `employee_id` = '" + element.rep_id + "'";
            let obj = { cmd: 'getList', query: query1 };
            this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
              .subscribe(data => {
                this.applicationConstants.appComp.hideBusyCursor();
                element.rep_name = data.data['list'][0]['name'];
              });

            // this.rep.forEach(rep => {
            //   if(rep.employee_id == element.rep_id )
            //   element.rep_name = rep.name;
            // });

          }
        });

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  newStoreEntry() {
    this.addDialogRef = this.dialog.open(StoreComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
        //console.log(this.acct_income);
      });
  }

  editStore(row) {
    let dialog_data = {
      'table_name': 'store', 'store_id': row.store_id,
      'store_name': row.store_name, 'store_name_en': row.store_name_en,
      'branch_id': row.branch_id, 'rep_id': row.rep_id, 'comment': row.comment
    };

    this.addDialogRef = this.dialog.open(StoreComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delStore(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'store_id': row.store_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }
}

